import {
  CHANGE_LANGUAGE,
  SET_LANGUAGE,
  FETCH_STORE,
  SET_PRODUCT,
  REDUCE_QUANTITY,
  FETCH_BRANCH,
  UPDATE_MOV,
  REDUCE_PROMO,
  RESET_TO_INITIAL_STATE,
  PRODUCTS_SECOND_FETCH,
  SECOND_LOADING,
  DELIVERY_CHARGES_SECOND_FETCH,
  MERGE_BRANCH_DELIVERY_CHARGES,
  BRANCH_BASED_THIRD_FETCH,
  CATEGORY_PRODUCT_LIST_FETCH,
  SAVE_SEARCH,
  DISABLE_PRODUCT_PREORDERING,
  LOAD_OPTIONS,
  LOAD_PRODUCT_DETAILS,
  LOAD_BRANCH_DETAILS,
  SET_SMART_PROMOS,
} from "../actions/actionTypes";
import { loadBranchDetails } from "../actions/store";

import { preciseNumber } from "./cart";

const initialState = {
  language: "english",
  store: null,
  current_product: null,
  isB2B: false,
  secondLoading: false,
  categoryLoading: false,
  variantsLoading: false,
  thirdLoading: false,
  fetchedDeliveryCharges: false,

  lastOpenedCategory: null,
  openedCategories: [],
  openedCategoriesInteracted: false,
  isNotificationDismissed: false,

  used_components: {},
};

const filterOnlineBranches = (branches = []) =>
  branches.filter((branch) => branch?.enable_online !== false);

const mergeById = (current = [], incoming = []) => {
  const merged = [...(current || [])];

  (incoming || []).forEach((item) => {
    if (!item || item.id === undefined || item.id === null) return;
    const existingIndex = merged.findIndex((entry) => entry?.id === item.id);
    if (existingIndex >= 0) {
      merged[existingIndex] = {
        ...merged[existingIndex],
        ...item,
      };
    } else {
      merged.push(item);
    }
  });

  return merged;
};

export function getProduct(categories, product_id, category_id, parent) {
  try {
    let product = categories.find((category) => category.id == category_id);

    if (parent) {
      product = product.products
        .find((item) => item.id == parent && item.has_variants)
        .children.find((item) => item.id == product_id);
    } else {
      product = product.products.find((item) => item.id == product_id);
    }

    return product;
  } catch {
    return null;
  }
}
function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

export function getProductUsedComponents(currentProduct, editedProduct) {
  if (!currentProduct) return {};

  const usedComponents = {};
  if (currentProduct.type_of_product === "composite") {
    Object.entries(currentProduct.components || {}).forEach(
      ([productId, { required_amount }]) => {
        usedComponents[productId] =
          (usedComponents[productId] || 0) + required_amount;
      }
    );
  } else if (currentProduct.type_of_product === "stocked") {
    usedComponents[currentProduct.id] = usedComponents[currentProduct.id] || 1;
  }
  if (editedProduct) {
    Object.values(editedProduct.options).forEach((option) => {
      Object.values(option.selectedOptions).forEach((ch) => {
        if (ch.maxInventory !== null && ch.related_product) {
          if (ch.related_product.type_of_product === "composite") {
            Object.entries(ch.related_product.components).forEach(
              ([productId, product]) => {
                let componentProductId = productId;
                if (option.quantity_exclusive) componentProductId += "Q";
                usedComponents[componentProductId] =
                  (usedComponents[componentProductId] || 0) +
                  ch.quantity * product.required_amount;
              }
            );
          } else {
            let componentProductId = ch.related_product.id;
            if (option.quantity_exclusive) componentProductId += "Q";

            usedComponents[componentProductId] =
              (usedComponents[componentProductId] || 0) + ch.quantity;
          }
        }
      });
    });
    editedProduct.prevUsedComponents = { ...usedComponents };
  }
  return usedComponents;
}
export function getProductInventory(product, usedComponents) {
  if (product.type_of_product == "stocked") {
    return product.inventory_on_hand - (usedComponents[product.id] || 0);
  }

  if (product.type_of_product == "composite") {
    return getCompositeInventory(product.components, usedComponents);
  }
  return Infinity;
}

function getCompositeInventory(productComponents, used_components) {
  let inventory = Infinity;
  let mainComponentInventory;
  let componentRequiredAmount;

  for (let component_id in productComponents) {
    if (productComponents[component_id].type_of_product !== "stocked") continue;
    mainComponentInventory = productComponents[component_id].inventory_on_hand;
    componentRequiredAmount = productComponents[component_id].required_amount;

    inventory = Math.min(
      inventory,
      preciseNumber(
        preciseNumber(
          mainComponentInventory - (used_components[component_id] || 0)
        ) / componentRequiredAmount
      )
    );
  }

  if (inventory == Infinity) return 999999;
  return inventory;
}

export function reduceComponentsInventories(
  compositeProduct,
  change,
  usedComponents
) {
  for (let product_id in compositeProduct.components) {
    const quantityDeduction = preciseNumber(
      change * compositeProduct.components[product_id].required_amount
    );

    usedComponents[product_id] =
      (usedComponents[product_id] || 0) + quantityDeduction;
  }
  return usedComponents;
}

export default (
  state = initialState,
  { type, payload, isPickup, asyncDispatch }
) => {
  switch (type) {
    case "REMOVE_CATEGORY_PASSWORD":
      let updatedStore = state.store;
      let idx = updatedStore.categories.findIndex((cat) => cat.id == payload);

      updatedStore.categories[idx].has_password = false;

      return { ...state, store: updatedStore };

    case "DISMISS_NOTIFICATION":
      return { ...state, isNotificationDismissed: true };
    case "SAVE_LAST_OPENED_CATEGORY":
      return { ...state, lastOpenedCategory: payload };
    case "UPDATE_CATEGORY_STATE":
      let thisOpenedCategories = state.openedCategories;
      // If the category is expanded, see if category is in array of opened categories. Add it if not.
      // If it is not expanded, then remove it from the array if it is in the array.
      // openedCategoriesInteracted is used to keep track of the first time the state is updated
      payload.expanded
        ? thisOpenedCategories.includes(payload.index)
          ? (thisOpenedCategories = thisOpenedCategories)
          : thisOpenedCategories.push(payload.index)
        : (thisOpenedCategories = thisOpenedCategories.filter(
            (e) => e !== payload.index
          ));
      return {
        ...state,
        openedCategories: thisOpenedCategories,
        openedCategoriesInteracted: true,
      };
    case "SET_B2B":
      return { ...state, isB2B: true };
    case UPDATE_MOV:
      let tempStore = state.store;
      if (!tempStore) return { ...state };
      tempStore.settings.minimum_order = payload;
      return { ...state, store: tempStore };
    case "CLEAR_STORE":
      return { ...state, store: null, current_product: null };
    case CHANGE_LANGUAGE:
      if (state.language == "english") {
        localStorage.setItem("language", "arabic");
        try {
          window.switchLuaArabic();
        } catch (e) {}
        return { ...state, language: "arabic" };
      } else {
        localStorage.setItem("language", "english");
        try {
          window.switchLuaEnglish();
        } catch (e) {}
        return { ...state, language: "english" };
      }
    case SET_LANGUAGE:
      if (payload === "arabic") {
        try {
          window.switchLuaArabic();
        } catch (e) {}
      } else {
        try {
          window.switchLuaEnglish();
        } catch (e) {}
      }
      return { ...state, language: payload };
    case FETCH_STORE:
      return { ...state, store: payload };
    case "CATEGORY_LOADING":
      return { ...state, categoryLoading: true };

    case CATEGORY_PRODUCT_LIST_FETCH:
      let newCategories = state.store.categories;
      let catIndex;

      catIndex = newCategories.findIndex(
        (cat) => cat.id == payload.category_id
      );
      let newProducts = payload.products || [];

      if (catIndex !== -1) {
        let existingProducts = newCategories[catIndex].products;
        let newProducts = payload.products || [];

        newCategories[catIndex].products = [
          ...existingProducts,
          ...newProducts,
        ].filter(
          (thing, index, self) =>
            index === self.findIndex((t) => t.id === thing.id)
        );
        newCategories[catIndex].has_loaded = true;
        newCategories[catIndex].pages_loaded = payload.pages_loaded || 1;
        newCategories[catIndex].pages = payload.pages || 1;

        newProducts.forEach((p) => {
          if (p.category_id !== payload.category_id) {
            catIndex = newCategories.findIndex(
              (cat) => cat.id == p.category_id
            );
            if (catIndex >= 0) {
              newCategories[catIndex].products = [
                ...newCategories[catIndex].products,

                p,
              ].filter(
                (thing, index, self) =>
                  index === self.findIndex((t) => t.id === thing.id)
              );
            }
          }
        });
      }
      let newStoreCat = state.store;
      newStoreCat.categories = newCategories;

      return {
        ...state,
        store: newStoreCat,
        categoryLoading: false,
      };
    case "SET_INVENTORY_ON_HAND_DISPLAY": {
      const newStore = state.store;
      const cart = payload;
      for (let product of cart) {
        let categoryIndex = newStore.categories.findIndex(
          (cat) => cat.id === product.category_id
        );

        let productIndex = newStore.categories[
          categoryIndex
        ].products.findIndex((prod) => prod.id === product.id);

        newStore.categories[categoryIndex].products[
          productIndex
        ].inventory_on_hand_display =
          newStore.categories[categoryIndex].products[
            productIndex
          ].inventory_on_hand;
      }

      return { ...state, store: newStore };
    }
    case REDUCE_QUANTITY:
      let newStore = state.store;
      let newUsedComponents = state.used_components;

      let product = getProduct(
        newStore?.categories,
        payload.product.id,
        payload.product.category_id,
        payload.product.parent
      );

      if (!product) {
        newUsedComponents[payload.product.id] =
          (newUsedComponents[payload.product.id] || 0) + payload.change;
        return { ...state, used_components: newUsedComponents };
      }
      if (payload.isPreordering) {
        product.preorder_inventory = preciseNumber(
          product.preorder_inventory - payload.change
        );
      } else {
        if (
          product.type_of_product === "bookable" &&
          payload.product.booking_slot
        ) {
          let bookingSlot = product.booking_slots.find(
            (slot) => slot.id === payload.product.booking_slot
          );
          bookingSlot.inventory = preciseNumber(
            bookingSlot.inventory - payload.change
          );
        }

        if (payload.maxAddableQuantity) {
          product.max_addable_quantity = payload.maxAddableQuantity;
        }
      }

      if (payload.disablePreordering) {
        product.allow_preordering = false;
      }

      // composite product
      if (product.type_of_product === "composite") {
        newUsedComponents = reduceComponentsInventories(
          product,
          payload.change,
          newUsedComponents
        );
      }

      if (product.type_of_product == "stocked") {
        newUsedComponents[product.id] =
          (newUsedComponents[product.id] || 0) + payload.change;
      }

      // Check if options has inventory
      ////////////////////////////////////////////////////////////////

      if (payload.product.options) {
        Object.values(payload.product.options).forEach((option) => {
          Object.values(option.selectedOptions).forEach((choice) => {
            if (
              choice.maxInventory !== null &&
              choice.related_product &&
              !(option.quantityExclusive && payload.fromEditQuantity)
            ) {
              const modifersQuantity =
                (!option.quantityExclusive &&
                  choice.quantity * payload.change) ||
                choice.quantity * Math.sign(payload.change);

              asyncDispatch({
                type: REDUCE_QUANTITY,
                payload: {
                  product: choice.related_product || {},
                  change: modifersQuantity,
                  isPreordering: false,
                },
              });
            }
          });
        });
      }
      ///////////////////////////////////////////////////////////////////////////////
      return {
        ...state,
        store: newStore,
        used_components: newUsedComponents,
      };
    case SET_PRODUCT:
      return { ...state, current_product: payload };
    case FETCH_BRANCH:
      let temp = JSON.parse(JSON.stringify(payload));
      temp.branches = filterOnlineBranches(temp.branches || []);
      if (isPickup) {
        temp.settings.minimum_order = 0;
      }

      let fetchedDeliveryCharges = state.fetchedDeliveryCharges;

      if (state.fetchedDeliveryCharges) {
        temp.delivery_charges = state.store.delivery_charges;
        temp.areas = state.store.areas;
        temp.countries = state.store.countries;
        temp.branch_delivery_charges = state.store.branch_delivery_charges;
        temp.branches = state.store.branches;
        temp.provinces = state.store.provinces;

        try {
          if (payload.branch_delivery_charges?.length === 1) {
            let bdcIndex = temp.branch_delivery_charges.findIndex(
              (bdc) => bdc.id === payload.branch_delivery_charges[0].id
            );
            if (
              bdcIndex >= 0 &&
              temp.branch_delivery_charges[bdcIndex].price !==
                payload.branch_delivery_charges[0].price
            ) {
              temp.branch_delivery_charges[bdcIndex].price =
                payload.branch_delivery_charges[0].price;
              fetchedDeliveryCharges = false;
            }
          }
        } catch (e) {
          console.error(e);
        }
      }

      return {
        ...state,
        store: temp,
        current_product: null,
        fetchedDeliveryCharges: fetchedDeliveryCharges,
      };

    case REDUCE_PROMO:
      let newStore_promo = state.store;
      let index = newStore_promo.promos.findIndex(
        (promo) => promo.id === payload
      );
      let promo = newStore_promo.promos[index];

      if (promo) {
        promo.user_quantity_used += 1;
        promo.remaining -= 1;
        if (promo.remaining <= 0) {
          newStore_promo.promos.splice(index, 1);
        }
      }

      return { ...state, store: newStore_promo };
    case RESET_TO_INITIAL_STATE:
      return { ...initialState };

    case SECOND_LOADING:
      return { ...state, secondLoading: true };
    case PRODUCTS_SECOND_FETCH:
      let newStr = state.store;
      let firstLoadCategories = newStr.categories;
      let secondLoadCategories = payload;

      const storeLayout = state.store.settings.store_layout;

      if (storeLayout.startsWith("grid")) {
        if (firstLoadCategories) {
          firstLoadCategories.forEach((cat) => {
            // Find the index in the new fetched categories
            const i = secondLoadCategories.findIndex((c) => c.id == cat.id);

            // If an old category contains products, put them in the new category's products
            if (
              cat.products &&
              i >= 0 &&
              !secondLoadCategories[i].has_children
            ) {
              secondLoadCategories[i].products = cat.products;
            }
          });
        }
      } else {
        if (firstLoadCategories) {
          firstLoadCategories.forEach((cat) => {
            // Find the index in the new fetched categories
            const i = secondLoadCategories.findIndex((c) => c.id == cat.id);

            // For each product in first load categories, compare inventory_on_hand with new fetched product
            if (cat.products && i >= 0) {
              cat.products.forEach((product) => {
                const pIndex = secondLoadCategories[i].products.findIndex(
                  (p) => p.id == product.id
                );
                if (pIndex == -1) {
                  secondLoadCategories[i].products = [
                    ...secondLoadCategories[i].products,
                    product,
                  ];
                } else if (pIndex >= 0) {
                  // If they're not equal (the item is in the cart), replace second with first
                  secondLoadCategories[i].products[pIndex] = product;
                }
              });
            }
          });
        }
      }
      secondLoadCategories.forEach((cat) => {
        if (cat.id == "newest" || cat.id == "most-selling") {
          if (cat.products.length) {
            cat.products.forEach((prod) => {
              let categoryIndex = secondLoadCategories.findIndex(
                (cat) => cat.id == prod.category_id
              );

              if (!secondLoadCategories[categoryIndex].has_children) {
                let productIndex = secondLoadCategories[
                  categoryIndex
                ].products.find((p) => p.id == prod.id);
                if (!productIndex) {
                  secondLoadCategories[categoryIndex].products = [
                    ...secondLoadCategories[categoryIndex].products,
                    prod,
                  ];
                }
              }
            });
          }
        }
      });

      // Removing parent categories if subcategories don't exist
      const allCategoryIDs = secondLoadCategories.map((y) => y.id);
      let categoriesToRemove = [];
      secondLoadCategories
        .filter((c) => !!c.sub_categories?.length)
        .forEach((c) => {
          if (!c.sub_categories.some((x) => allCategoryIDs.includes(x)))
            categoriesToRemove.push(c.id);
        });
      secondLoadCategories = secondLoadCategories.filter(
        (c) => !categoriesToRemove.includes(c.id)
      );
      newStr.categories = secondLoadCategories;

      return {
        ...state,
        store: newStr,
        secondLoading: false,
        thirdLoading: false,
      };

    case DELIVERY_CHARGES_SECOND_FETCH:
      let newStr2 = state.store;
      newStr2.delivery_charges = payload.delivery_charges;
      newStr2.areas = payload.areas;
      newStr2.countries = payload.countries;
      newStr2.branch_delivery_charges = payload.branch_delivery_charges;
      newStr2.branches = filterOnlineBranches(payload.branches || []);
      newStr2.provinces = payload.provinces;

      return {
        ...state,
        store: newStr2,
        thirdLoading: false,
        fetchedDeliveryCharges: true,
      };

    case MERGE_BRANCH_DELIVERY_CHARGES:
      if (!state.store) return state;

      return {
        ...state,
        store: {
          ...state.store,
          branch_delivery_charges: mergeById(
            state.store.branch_delivery_charges,
            payload.branch_delivery_charges,
          ),
          countries: mergeById(state.store.countries, payload.countries),
          branches: mergeById(state.store.branches, payload.branches),
        },
      };

    case BRANCH_BASED_THIRD_FETCH:
      let newStr3 = state.store;
      newStr3.delivery_charges = payload.delivery_charges;
      newStr3.areas = payload.areas;
      newStr3.branch_delivery_charges = payload.branch_delivery_charges;
      return { ...state, store: newStr3, thirdLoading: false };

    case SAVE_SEARCH:
      let newStr4 = state.store;

      payload.forEach((product, pIndex) => {
        // This must exist NOT ALWAYS
        let categoryIndx = newStr4.categories.findIndex(
          (cat) => cat.id == product.category_id
        );

        let prodIndex = newStr4.categories[categoryIndx].products.findIndex(
          (prod) => prod.id == product.id
        );
        if (prodIndex >= 0) {
          payload[pIndex] =
            newStr4.categories[categoryIndx].products[prodIndex];
        } else {
          // Product doesn't exist in redux, add it
          // Order of the products doesn't matter

          newStr4.categories[categoryIndx].products = [
            product,
            ...newStr4.categories[categoryIndx].products,
          ];
        }
      });

      // payload.forEach((category) => {
      //   if (newStr4.categories.length) {
      //     // This must exist NOT ALWAYS
      //     let categoryIndx = newStr4.categories.findIndex(
      //       (cat) => cat.id == category.id
      //     );

      //     category.products.forEach((product, index) => {
      //       let prodIndex = newStr4.categories[categoryIndx].products.findIndex(
      //         (prod) => prod.id == product.id
      //       );
      //       if (prodIndex >= 0) {
      //         category.products[index] =
      //           newStr4.categories[categoryIndx].products[prodIndex];
      //       } else {
      //         // Product doesn't exist in redux, add it
      //         // Order of the products doesn't matter

      //         newStr4.categories[categoryIndx].products = [
      //           product,
      //           ...newStr4.categories[categoryIndx].products,
      //         ];
      //       }
      //     });
      //   }
      // });

      return {
        ...state,
        store: newStr4,
      };

    case "STORE_PAST_ORDER_PRODUCTS":
      let newStr5 = state.store;

      payload.forEach((order) => {
        order.items.forEach((item) => {
          let cIndex = newStr5.categories.findIndex(
            (c) => c.id == item.product.category_id
          );
          if (cIndex >= 0) {
            let productExists = newStr5.categories[cIndex].products.find(
              (p) => p.id == item.product.id
            );

            if (!productExists) {
              newStr5.categories[cIndex].products = [
                ...newStr5.categories[cIndex].products,
                item.product,
              ];
            } else {
              if (!productExists.options.length) {
                productExists.options = item.product.options;
                productExists.options_groups = item.product.options_groups;
              }
              if (!productExists.extra_fields.length) {
                productExists.extra_fields = item.product.extra_fields;
              }
              if (
                productExists.has_variants &&
                !productExists.children.length
              ) {
                productExists.children = item.product.children;
              }
            }
          }
        });
      });

      return { ...state, store: newStr5 };

    case "SET_USED_COMPONENTS":
      return { ...state, used_components: payload };

    case "VARIANTS_LOADING":
      return { ...state, variantsLoading: true };
    case "LOAD_VARIANTS":
      let newCats = state.store.categories;
      let tmpCatIndex = newCats.findIndex((x) => x.id == payload.category_id);
      let tmpProdIndex = newCats[tmpCatIndex].products.findIndex(
        (x) => x.id == payload.parent_id
      );
      newCats[tmpCatIndex].products[tmpProdIndex].children = payload.products;
      let newStor = state.store;
      newStor.categories = newCats;
      return { ...state, store: newStor, variantsLoading: false };
    case LOAD_OPTIONS:
      let newCategories2 = state.store.categories;
      let productCategory = newCategories2.find(
        (c) => c.id == payload.category_id
      );
      if (productCategory) {
        let product = productCategory.products.find(
          (p) => p.id === payload.product_id
        );
        if (product) {
          product.options = payload.options;
          product.options_groups = payload.options_groups || [];
        }
      }
      let newStor2 = state.store;
      newStor2.categories = newCategories2;
      return { ...state, store: { ...newStor2 } };

    case LOAD_PRODUCT_DETAILS:
      let newStor3 = state.store;
      let newCategories3 = newStor3.categories;
      let product3Index;
      let productCategory3 = newCategories3.find(
        (c) => c.id == payload.category_id
      );
      if (productCategory3) {
        product3Index = productCategory3.products.findIndex(
          (p) => p.id === payload.product_id
        );

        if (product3Index >= 0) {
          productCategory3.products[product3Index] = {
            ...productCategory3.products[product3Index],
            has_loaded: true,
            ...payload.productDetails,
          };

          return {
            ...state,
            current_product: productCategory3.products[product3Index],
          };
        }
      }
      return { ...state };

    case "DISABLE_MENU_MODE":
      let tStore = state.store;
      tStore.settings.is_menu = false;
      tStore.settings.enable_pickup = true;
      return { ...state, store: tStore };

    case "TURN_ON_MENU":
      let tStore2 = state.store;
      tStore2.settings.is_menu = true;
      tStore2.settings.enable_pickup = false;
      return { ...state, store: tStore2 };

    case "DISABLE_TABLE_QR":
      let _store = state.store;
      _store.settings.enable_table_qr = false;
      _store.settings.enable_car_qr = false;
      return { ...state, store: _store };

    case "RESET_SHOULD_FORCE_AREA_SELECT":
      let tStore3 = state.store;
      tStore3.should_force_area_select = false;

      return { ...state, store: tStore3 };

    case "DISABLE_TAP_CREDIT":
      let tStore4 = state.store;
      tStore4.settings.tap_pk = "";
      return { ...state, store: tStore4 };

    case "LOAD_FEEDBACK": {
      let newCategories2 = state.store.categories;
      let productCategory = newCategories2.find(
        (c) => c.id === payload.categoryID
      );
      if (productCategory) {
        //is a variant of a product
        if (payload.parentID) {
          let product = productCategory.products.find(
            (p) => p.id === payload.parentID
          );
          if (product) {
            let child = product.children.find(
              (p) => p.id === payload.productID
            );
            if (child) {
              child.feedback =
                child?.feedback === undefined
                  ? [...payload.data.data]
                  : [...child?.feedback, ...payload.data.data];
              child.feedback_total_pages = payload.data.pages_count;
              child.feedback_page =
                child.feedback_page === undefined ? 1 : ++child.feedback_page;
            }
          }
        } else {
          let product = productCategory.products.find(
            (p) => p.id === payload.productID
          );
          if (product) {
            product.feedback =
              product?.feedback === undefined
                ? [...payload.data.data]
                : [...product?.feedback, ...payload.data.data];
            product.feedback_total_pages = payload.data.pages_count;
            product.feedback_page =
              product.feedback_page === undefined ? 1 : ++product.feedback_page;
          }
        }
      }
      let newStor2 = state.store;
      newStor2.categories = newCategories2;
      return { ...state, store: { ...newStor2 } };
    }

    case LOAD_BRANCH_DETAILS:
      const newBranches = state.store.branches || [];
      let branchIndex = state.store.branches.findIndex(
        (b) => b.id === payload.id
      );
      if (branchIndex !== -1) {
        newBranches[branchIndex] = {
          ...newBranches[branchIndex],
          loaded_details: true,
          ...payload,
        };
      }
      return { ...state, store: { ...state.store, branches: newBranches } };

    case SET_SMART_PROMOS:
      return { ...state, store: { ...state.store, smart_promos: payload } };

    default:
      return state;
  }
};
